import { PdApiActions, PdApiActionsEnum } from "../actions/pdApiActions";
import { filterOptionsInitialState } from "./initialState";

const filterReducer = (
  state: State.FilterOptions = filterOptionsInitialState,
  action: PdApiActions
): State.FilterOptions => {
  switch (action.type) {
    case PdApiActionsEnum.SET_FILTER_OPTIONS: {
      const updated = action.payload;
      return { ...state, ...updated };
    }
    default:
      return state;
  }
};

export default filterReducer;
